// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file plugin_update_service.proto (package pipeex.pluginupdate.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file plugin_update_service.proto.
 */
export const file_plugin_update_service: GenFile = /*@__PURE__*/
  fileDesc("ChtwbHVnaW5fdXBkYXRlX3NlcnZpY2UucHJvdG8SFnBpcGVleC5wbHVnaW51cGRhdGUudjEiHQobR2V0UGx1Z2luVXBkYXRlU3RhdGVSZXF1ZXN0IiEKH1JlZnJlc2hQbHVnaW5VcGRhdGVTdGF0ZVJlcXVlc3QiIgogU3RhcnRQbHVnaW5VcGRhdGVEb3dubG9hZFJlcXVlc3Qi5gMKGVBsdWdpblVwZGF0ZVN0YXRlUmVzcG9uc2USOAoFc3RhdGUYASABKA4yKS5waXBlZXgucGx1Z2ludXBkYXRlLnYxLlBsdWdpblVwZGF0ZVN0YXRlEhkKEWluc3RhbGxlZF92ZXJzaW9uGAIgASgJEhYKDmxhdGVzdF92ZXJzaW9uGAMgASgJEg8KB2NoYW5uZWwYBCABKAkSDgoGc2hhMjU2GAUgASgJEhIKCnNpemVfYnl0ZXMYBiABKAMSGQoRcmVsZWFzZV9ub3Rlc191cmwYByABKAkSFAoMZG93bmxvYWRfdXJsGAggASgJEhsKE2xhc3RfY2hlY2tlZF9hdF91dGMYCSABKAkSFQoNZXJyb3JfbWVzc2FnZRgKIAEoCRIhChlkb3dubG9hZF9wcm9ncmVzc19wZXJjZW50GAsgASgFEhYKDnN0YWdlZF92ZXJzaW9uGAwgASgJEhYKDmZhaWx1cmVfcmVhc29uGA0gASgJEhEKCWNhbl9yZXRyeRgOIAEoCBIeChZpc19iZWxvd19taW5fc3VwcG9ydGVkGA8gASgIEh0KFW1pbl9zdXBwb3J0ZWRfdmVyc2lvbhgQIAEoCRIdChVhdXRvX2Rvd25sb2FkX2VuYWJsZWQYESABKAgq4gIKEVBsdWdpblVwZGF0ZVN0YXRlEh8KG1BMVUdJTl9VUERBVEVfU1RBVEVfVU5LTk9XThAAEiAKHFBMVUdJTl9VUERBVEVfU1RBVEVfQ0hFQ0tJTkcQARIiCh5QTFVHSU5fVVBEQVRFX1NUQVRFX1VQX1RPX0RBVEUQAhIoCiRQTFVHSU5fVVBEQVRFX1NUQVRFX1VQREFURV9BVkFJTEFCTEUQAxIkCiBQTFVHSU5fVVBEQVRFX1NUQVRFX0NIRUNLX0ZBSUxFRBAEEiMKH1BMVUdJTl9VUERBVEVfU1RBVEVfRE9XTkxPQURJTkcQBRIhCh1QTFVHSU5fVVBEQVRFX1NUQVRFX1ZFUklGWUlORxAGEiYKIlBMVUdJTl9VUERBVEVfU1RBVEVfUkVBRFlfVE9fQVBQTFkQBxImCiJQTFVHSU5fVVBEQVRFX1NUQVRFX0lOU1RBTExfRkFJTEVEEAgyqQMKE1BsdWdpblVwZGF0ZVNlcnZpY2USfgoUR2V0UGx1Z2luVXBkYXRlU3RhdGUSMy5waXBlZXgucGx1Z2ludXBkYXRlLnYxLkdldFBsdWdpblVwZGF0ZVN0YXRlUmVxdWVzdBoxLnBpcGVleC5wbHVnaW51cGRhdGUudjEuUGx1Z2luVXBkYXRlU3RhdGVSZXNwb25zZRKGAQoYUmVmcmVzaFBsdWdpblVwZGF0ZVN0YXRlEjcucGlwZWV4LnBsdWdpbnVwZGF0ZS52MS5SZWZyZXNoUGx1Z2luVXBkYXRlU3RhdGVSZXF1ZXN0GjEucGlwZWV4LnBsdWdpbnVwZGF0ZS52MS5QbHVnaW5VcGRhdGVTdGF0ZVJlc3BvbnNlEogBChlTdGFydFBsdWdpblVwZGF0ZURvd25sb2FkEjgucGlwZWV4LnBsdWdpbnVwZGF0ZS52MS5TdGFydFBsdWdpblVwZGF0ZURvd25sb2FkUmVxdWVzdBoxLnBpcGVleC5wbHVnaW51cGRhdGUudjEuUGx1Z2luVXBkYXRlU3RhdGVSZXNwb25zZUIQqgINUGlwZWVYLlByb3Rvc2IGcHJvdG8z");

/**
 * @generated from message pipeex.pluginupdate.v1.GetPluginUpdateStateRequest
 */
export type GetPluginUpdateStateRequest = Message<"pipeex.pluginupdate.v1.GetPluginUpdateStateRequest"> & {
};

/**
 * Describes the message pipeex.pluginupdate.v1.GetPluginUpdateStateRequest.
 * Use `create(GetPluginUpdateStateRequestSchema)` to create a new message.
 */
export const GetPluginUpdateStateRequestSchema: GenMessage<GetPluginUpdateStateRequest> = /*@__PURE__*/
  messageDesc(file_plugin_update_service, 0);

/**
 * @generated from message pipeex.pluginupdate.v1.RefreshPluginUpdateStateRequest
 */
export type RefreshPluginUpdateStateRequest = Message<"pipeex.pluginupdate.v1.RefreshPluginUpdateStateRequest"> & {
};

/**
 * Describes the message pipeex.pluginupdate.v1.RefreshPluginUpdateStateRequest.
 * Use `create(RefreshPluginUpdateStateRequestSchema)` to create a new message.
 */
export const RefreshPluginUpdateStateRequestSchema: GenMessage<RefreshPluginUpdateStateRequest> = /*@__PURE__*/
  messageDesc(file_plugin_update_service, 1);

/**
 * @generated from message pipeex.pluginupdate.v1.StartPluginUpdateDownloadRequest
 */
export type StartPluginUpdateDownloadRequest = Message<"pipeex.pluginupdate.v1.StartPluginUpdateDownloadRequest"> & {
};

/**
 * Describes the message pipeex.pluginupdate.v1.StartPluginUpdateDownloadRequest.
 * Use `create(StartPluginUpdateDownloadRequestSchema)` to create a new message.
 */
export const StartPluginUpdateDownloadRequestSchema: GenMessage<StartPluginUpdateDownloadRequest> = /*@__PURE__*/
  messageDesc(file_plugin_update_service, 2);

/**
 * @generated from message pipeex.pluginupdate.v1.PluginUpdateStateResponse
 */
export type PluginUpdateStateResponse = Message<"pipeex.pluginupdate.v1.PluginUpdateStateResponse"> & {
  /**
   * @generated from field: pipeex.pluginupdate.v1.PluginUpdateState state = 1;
   */
  state: PluginUpdateState;

  /**
   * Version of the plugin currently running in this Revit session.
   *
   * @generated from field: string installed_version = 2;
   */
  installedVersion: string;

  /**
   * Latest version advertised by the API for the channel (empty until a check succeeds).
   *
   * @generated from field: string latest_version = 3;
   */
  latestVersion: string;

  /**
   * Release channel the check used (e.g. "stable").
   *
   * @generated from field: string channel = 4;
   */
  channel: string;

  /**
   * SHA-256 of the latest bundle, from the manifest.
   *
   * @generated from field: string sha256 = 5;
   */
  sha256: string;

  /**
   * Size in bytes of the latest bundle, from the manifest.
   *
   * @generated from field: int64 size_bytes = 6;
   */
  sizeBytes: bigint;

  /**
   * Optional release-notes URL for the latest version.
   *
   * @generated from field: string release_notes_url = 7;
   */
  releaseNotesUrl: string;

  /**
   * Download URL for the latest bundle.
   *
   * @generated from field: string download_url = 8;
   */
  downloadUrl: string;

  /**
   * UTC timestamp (RFC 3339) of the last completed check; empty if never checked.
   *
   * @generated from field: string last_checked_at_utc = 9;
   */
  lastCheckedAtUtc: string;

  /**
   * Human-readable failure detail when state == CHECK_FAILED.
   *
   * @generated from field: string error_message = 10;
   */
  errorMessage: string;

  /**
   * Download progress 0-100; meaningful while state == DOWNLOADING.
   *
   * @generated from field: int32 download_progress_percent = 11;
   */
  downloadProgressPercent: number;

  /**
   * Version staged and awaiting a Revit restart; non-empty when state == READY_TO_APPLY.
   *
   * @generated from field: string staged_version = 12;
   */
  stagedVersion: string;

  /**
   * Machine-readable failure code (snake_case) when state == INSTALL_FAILED; the
   * human-readable detail stays in error_message (10).
   *
   * @generated from field: string failure_reason = 13;
   */
  failureReason: string;

  /**
   * Whether the failed install can be retried (Retry button).
   *
   * @generated from field: bool can_retry = 14;
   */
  canRetry: boolean;

  /**
   * Whether the installed version is below the manifest's minimum supported version.
   *
   * @generated from field: bool is_below_min_supported = 15;
   */
  isBelowMinSupported: boolean;

  /**
   * The manifest's minimum supported version (empty when not advertised).
   *
   * @generated from field: string min_supported_version = 16;
   */
  minSupportedVersion: string;

  /**
   * Whether background auto-download is enabled (config update.autoDownload).
   *
   * @generated from field: bool auto_download_enabled = 17;
   */
  autoDownloadEnabled: boolean;
};

/**
 * Describes the message pipeex.pluginupdate.v1.PluginUpdateStateResponse.
 * Use `create(PluginUpdateStateResponseSchema)` to create a new message.
 */
export const PluginUpdateStateResponseSchema: GenMessage<PluginUpdateStateResponse> = /*@__PURE__*/
  messageDesc(file_plugin_update_service, 3);

/**
 * Lifecycle state of the update check. Mirrors
 * Pipeex.General.PluginUpdate.PluginUpdateState.
 *
 * @generated from enum pipeex.pluginupdate.v1.PluginUpdateState
 */
export enum PluginUpdateState {
  /**
   * @generated from enum value: PLUGIN_UPDATE_STATE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: PLUGIN_UPDATE_STATE_CHECKING = 1;
   */
  CHECKING = 1,

  /**
   * @generated from enum value: PLUGIN_UPDATE_STATE_UP_TO_DATE = 2;
   */
  UP_TO_DATE = 2,

  /**
   * @generated from enum value: PLUGIN_UPDATE_STATE_UPDATE_AVAILABLE = 3;
   */
  UPDATE_AVAILABLE = 3,

  /**
   * @generated from enum value: PLUGIN_UPDATE_STATE_CHECK_FAILED = 4;
   */
  CHECK_FAILED = 4,

  /**
   * @generated from enum value: PLUGIN_UPDATE_STATE_DOWNLOADING = 5;
   */
  DOWNLOADING = 5,

  /**
   * @generated from enum value: PLUGIN_UPDATE_STATE_VERIFYING = 6;
   */
  VERIFYING = 6,

  /**
   * @generated from enum value: PLUGIN_UPDATE_STATE_READY_TO_APPLY = 7;
   */
  READY_TO_APPLY = 7,

  /**
   * @generated from enum value: PLUGIN_UPDATE_STATE_INSTALL_FAILED = 8;
   */
  INSTALL_FAILED = 8,
}

/**
 * Describes the enum pipeex.pluginupdate.v1.PluginUpdateState.
 */
export const PluginUpdateStateSchema: GenEnum<PluginUpdateState> = /*@__PURE__*/
  enumDesc(file_plugin_update_service, 0);

/**
 * Plugin self-update state bridge.
 * 
 * The Revit plugin polls the API's GET /api/plugin/manifest endpoint, compares
 * the published version to the installed assembly version, and caches the result
 * in memory. The embedded React WebView UI reads that cached state over this
 * service (GetPluginUpdateState) and can force an immediate re-check
 * (RefreshPluginUpdateState). Network/manifest work happens entirely on the
 * plugin side; the UI only observes the resulting state.
 *
 * @generated from service pipeex.pluginupdate.v1.PluginUpdateService
 */
export const PluginUpdateService: GenService<{
  /**
   * Return the cached update state (does not trigger a network call).
   *
   * @generated from rpc pipeex.pluginupdate.v1.PluginUpdateService.GetPluginUpdateState
   */
  getPluginUpdateState: {
    methodKind: "unary";
    input: typeof GetPluginUpdateStateRequestSchema;
    output: typeof PluginUpdateStateResponseSchema;
  },
  /**
   * Force an immediate manifest check, then return the refreshed state.
   *
   * @generated from rpc pipeex.pluginupdate.v1.PluginUpdateService.RefreshPluginUpdateState
   */
  refreshPluginUpdateState: {
    methodKind: "unary";
    input: typeof RefreshPluginUpdateStateRequestSchema;
    output: typeof PluginUpdateStateResponseSchema;
  },
  /**
   * Idempotent manual download trigger (Retry button / autoDownload=false). A
   * repeat call while a download/staged version is already active is a no-op that
   * returns the current snapshot without starting a second engine run.
   *
   * @generated from rpc pipeex.pluginupdate.v1.PluginUpdateService.StartPluginUpdateDownload
   */
  startPluginUpdateDownload: {
    methodKind: "unary";
    input: typeof StartPluginUpdateDownloadRequestSchema;
    output: typeof PluginUpdateStateResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_plugin_update_service, 0);

